module.exports = __webpack_public_path__ + "static/media/history.68c81423.png";